import { BaseController } from '../../../../base_controller';

export default class extends BaseController {
  static targets = [];

  static values = {
    contextLoaded: Boolean,
    macWorkaroundNeeded: Boolean,
  };

  declare contextLoadedValue: boolean;
  declare macWorkaroundNeededValue: boolean;

  connect(): void {
    if (this.isContextLoaded()) {
      this.clearContextRefreshAttemptedFlag();
    } else {
      this.runMacWorkaroundIfNeeded();
    }
  }

  // private methods

  private isContextLoaded(): boolean {
    return this.contextLoadedValue;
  }

  private clearContextRefreshAttemptedFlag(): void {
    if (localStorage.getItem('zoomContextRefreshAttempted')) {
      localStorage.removeItem('zoomContextRefreshAttempted');
    }
  }

  private setContextRefreshAttemptedFlag(): void {
    localStorage.setItem('zoomContextRefreshAttempted', 'true');
  }

  private hasAttemptedContextRefresh(): boolean {
    return localStorage.getItem('zoomContextRefreshAttempted') === 'true';
  }

  private runMacWorkaroundIfNeeded(): void {
    if (this.macWorkaroundNeededValue) {
      // Set a flag in localStorage to prevent infinite refresh loops
      if (!this.hasAttemptedContextRefresh()) {
        this.logger('Zoom Mac Workaround triggered', null, '#b526b0');
        this.setContextRefreshAttemptedFlag();
        // Wait a brief moment to ensure any initial loading is complete
        // Perform the refresh; hopefully the context will be available after
        setTimeout(() => {
          window.location.reload();
        }, 500);
      } else {
        // We've already tried refreshing but still don't have context
        // Clear the flag for next session
        this.clearContextRefreshAttemptedFlag();
        console.error('Zoom context still missing after refresh attempt');
      }
    }
  }
}
